<template src="./PanzoomImagesContainer.html" />

<script>
// components
import GraphicAnimation from '../common/GraphicAnimation/GraphicAnimation'
import panZoom from "vue-panzoom"

export default {
  name: "PanzoomImagesContainer",
  data() {
    return {
      state: false,
      id: this.$store.state.panzoomCounter
    }
  },
  props: {
    imageSrc: {
      default: '',
      type: [String, Array],
      required: true
    },
    condition: {
      default: true,
      type: Boolean
    }
  },
  components: {
    GraphicAnimation
  },
  methods: {
    panEnd(e) {
      this.panZoom = e;

      if (visualViewport.scale > 1) {
        this.panZoom.pause();
      }

      clearTimeout(this.debounceField);

      this.debounceField = setTimeout(() => {
        const viewportWidth = window.innerWidth;
        const imageWidth = viewportWidth * e.getTransform().scale;
        const viewportCenter = viewportWidth / 2;
        const imageCenter = viewportCenter * e.getTransform().scale;
        const scrolledFromCenterPx =
            viewportCenter - (e.getTransform().x + imageCenter);
        const scrolledFromCenterAbsPx = Math.abs(scrolledFromCenterPx);
        const scrolledFromCenterPercent = Math.abs(
            (scrolledFromCenterAbsPx * 100) / imageWidth
        );

        if (scrolledFromCenterPercent > 30) {
          e.smoothMoveTo(0, 0);
        }

        this.panZoom.resume();
      }, 500);
    },
    panzoomOnClick(state, condition = true) {
      if(condition) {
        this.state = state;
      }
    }
  },
  created() {
    this.$store.dispatch('INCREASE_PANZOOM_COUNTER');
  }
}
</script>

<style scoped lang="scss" src="./PanzoomImagesContainer.scss" />
